<template>
  <form
    ref="form"
    data-url="/organizations"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("name") }}</label>
          <app-input
            type="text"
            v-model="inputs.name"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("business_name") }}</label>
          <app-input
            type="text"
            v-model="inputs.business_name"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("integration_social_capital") }}</label>
          <app-input
            type="select"
            v-model="inputs.national_capital"
            :required="true"
            :list="[{ id: '', value: this.$t('select_option') }, ...percentage]"
            disabled
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("foreign_capital") }}</label>
          <app-input
            type="number"
            v-model="inputs.foreign_capital"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("legal_representative") }}</label>
          <app-input
            type="text"
            v-model="inputs.legal_representative"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("taxid") }}</label>
          <app-input
            type="number"
            v-model="inputs.taxid"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("country") }}</label>
          <app-input
            type="select"
            v-model="inputs.country_id"
            :required="true"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...this.$store.state.common.countries,
            ]"
            :disabled="true"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("province") }}</label>
          <app-input
            type="select"
            v-model="inputs.province_id"
            :required="true"
            :list="[
              { id: '', value: this.$t('select_option') },
              ...provinceList,
            ]"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("canton") }}</label>
          <app-input
            type="select"
            v-model="inputs.canton_id"
            :required="true"
            :list="[{ id: '', value: this.$t('select_option') }, ...cantonList]"
            :disabled="true"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("phone") }}</label>
          <app-input
            type="tel-input"
            v-model="inputs.phone"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("fax") }}</label>
          <app-input
            type="tel-input"
            v-model="inputs.fax"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("address") }}</label>
          <app-input
            type="textarea"
            v-model="inputs.address"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("web") }}</label>
          <app-input
            type="text"
            v-model="inputs.web"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("total_employees") }}</label>
          <app-input
            type="number"
            v-model="inputs.total_employees"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("fixed_auditors") }}</label>
          <app-input
            type="number"
            v-model="inputs.fixed_auditors"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("external_auditors") }}</label>
          <app-input
            type="number"
            v-model="inputs.external_auditors"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("total_critical_locations") }}</label>
          <app-input
            type="number"
            v-model="inputs.total_critical_locations"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ $t("countries_operates") }}</label>
          <app-input
            type="textarea"
            v-model="inputs.countries_operates"
            :required="true"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <!-- <div class="mt-5">
      <button
        type="submit"
        class="btn btn-primary mr-2"
        @click.prevent="submit"
      >
        {{ $t("save") }}
      </button>
    </div> -->
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";
export default {
  name: "General",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      provinceList: [],
      cantonList: [],
      percentage: Array.from(Array(100).keys()).map((i) => {
        return { id: i + 1, value: i + 1 };
      }),
    };
  },
  created() {
    this.data();
  },
  watch: {
    "inputs.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
    },

    "inputs.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },

    "$store.state.common.countries": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );

      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },

    "inputs.national_capital": function () {
      this.inputs.foreign_capital = 100 - this.inputs.national_capital;
    },
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.save(this.inputs);
      this.$store.state.accreditation.org = { ...this.inputs };
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.$store.dispatch("getPoliticalDivision");

      if (this.$store.state.accreditation.org) {
        this.inputs = { ...this.$store.state.accreditation.org };
        return;
      }

      this.preloader = true;
      setTimeout(() => {
        var organization_id = localStorage.getItem("id_organization");
        this.axiosGet(`${actions.ORGANIZATIONS}/index/${organization_id}`)
          .then((response) => {
            if (response.status == 200) {
              this.inputs = response.data ? response.data : {};
              this.$store.state.accreditation.org = { ...this.inputs };
            }
          })
          .catch((error) => {
            console.log("General: " + error);
          })
          .finally(() => {
            this.preloader = false;
          });
      }, 200);
    },
  },
};
</script>
